import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

const TextosFaqs = ({ lang, faqs }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";

    return (
        <>
            <section className="u-clearfix u-image u-valign-middle u-section-1" id="sec-5458" data-image-width="1680" data-image-height="1024">
                <h1 className="u-align-center u-custom-font u-font-oswald u-text u-text-default u-text-white u-title u-text-1">{t("Preguntas frecuentes").toUpperCase()}</h1>
            </section>
            <section className="u-align-center u-clearfix u-container-align-center u-section-2" id="sec-fdf0">
                <p className="u-align-center-xs u-align-left-lg u-align-left-md u-align-left-sm u-align-left-xl u-custom-font u-font-montserrat u-text u-text-default u-text-1"> {t("Hola, ¿cómo podemos ayudarle?")} </p>
                <div className="custom-expanded u-accordion u-faq u-spacing-20 u-accordion-1" role="tablist">
                    {
                        faqs.map((faq, index) => (
                            <div className={"u-accordion-item u-accordion-item-" + (index + 1)} key={index}>
                                <a className={"u-accordion-link u-border-1 u-border-active-grey-75 u-border-grey-15 u-border-hover-grey-75 u-border-no-left u-border-no-right u-border-no-top u-button-style u-text-black u-accordion-link-" + (index + 1) + (index == 0 ? " active" : "")} id={"link-accordion-" + (index + 10)} aria-controls={"accordion-" + (index + 10)} aria-selected={index == 0 ? "true" : "false"} role="tab">
                                    <span className="u-accordion-link-text">{faq.pregunta[lang]}</span>
                                    <span className="u-accordion-link-icon u-icon u-icon-rectangle u-text-active-black u-text-black u-text-hover-black u-icon-1">
                                        <svg className="u-svg-link" preserveAspectRatio="xMidYMin slice" viewBox="0 0 16 16">
                                            <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-8021"></use>
                                        </svg>
                                        <svg className="u-svg-content" viewBox="0 0 16 16" x="0px" y="0px" id="svg-8021">
                                            <path d="M8,10.7L1.6,5.3c-0.4-0.4-1-0.4-1.3,0c-0.4,0.4-0.4,0.9,0,1.3l7.2,6.1c0.1,0.1,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2l7.1-6
            c0.4-0.4,0.4-0.9,0-1.3c-0.4-0.4-1-0.4-1.3,0L8,10.7z"></path>
                                        </svg>
                                    </span>
                                </a>
                                <div className={"u-accordion-pane u-container-style u-accordion-pane-" + (index + 1) + (index == 0 ? " u-accordion-active" : "")} id={"accordion-" + (index + 10)} aria-labelledby={"link-accordion-" + (index + 10)} role="tabpanel">
                                    <div className={"u-container-layout u-container-layout-" + (index + 1)}>
                                        <div className="fr-view u-clearfix u-rich-text u-text">
                                            {ReactHtmlParser(faq.respuesta[lang])}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
                <div className="u-align-center u-container-align-center u-container-style u-expanded-width u-group u-shape-rectangle u-white u-group-1" data-animation-out="0">
                    <div className="u-container-layout u-valign-middle u-container-layout-10">
                        <p className="u-align-center u-text u-text-11" data-animation-name="fadeIn" data-animation-duration="1000" data-animation-delay="0"><span style={{ fontStyle: "normal" }}> {t("Si tienes más preguntas o necesitas información adicional, no dudes en contactarnos.")}</span>
                            <br /><span style={{ fontWeight: "400" }}>{t("Estamos aquí para ayudarte a planear unas inolvidables vacaciones en el mar")}</span>
                            <br />
                        </p>
                    </div>
                </div>

                <a href={"/" + preidioma + t("contacto")} className="u-border-2 u-border-white u-btn u-btn-round u-button-style u-custom-color-5 u-hover-custom-color-10 u-radius u-btn-1" title="CONTACTO" target="_blank">{t("Contáctanos").toUpperCase()} </a>
            </section>
            <section className="u-clearfix u-section-3" id="block-11"></section>
        </>
    );
}

export default TextosFaqs;
